module.exports = __webpack_public_path__ + "static/media/20.1d42ae1b.jpg";